import styled, { css } from "styled-components";
import { setPosition, setFlex } from "../variables/utils";
import { BREAKPOINTS } from "../variables/breakpoints";

const setFontStyle = id => {
  switch (id) {
    case 1:
      return css`
        font-family: outward-block;
        font-size: 25rem;
        line-height: 25rem;

        @media (max-width: ${BREAKPOINTS.lg}px) {
          font-size: 20rem;
          line-height: 20rem;
        }
        @media (max-width: ${BREAKPOINTS.sm}px) {
          font-size: 18rem;
          line-height: 18rem;
        }
        @media (max-width: ${BREAKPOINTS.xxs}px) {
          font-size: 16rem;
          line-height: 16rem;
        }
        @media (max-width: ${BREAKPOINTS.xxxs}px) {
          font-size: 13rem;
          line-height: 13rem;
        }
      `;
    case 2:
      return css`
        font-family: thunder-blacklc;
        font-size: 23rem;
        line-height: 23rem;
        letter-spacing: 0.15rem;
        @media (max-width: ${BREAKPOINTS.lg}px) {
          font-size: 18rem;
          line-height: 18rem;
        }
        @media (max-width: ${BREAKPOINTS.sm}px) {
          font-size: 16rem;
          line-height: 16rem;
        }
        @media (max-width: ${BREAKPOINTS.xs}px) {
          font-size: 14rem;
          line-height: 14rem;
        }
        @media (max-width: ${BREAKPOINTS.xxxs}px) {
          font-size: 11.5rem;
          line-height: 11.5rem;
        }
      `;
    case 3:
      return css`
        font-family: being-regular;
        font-size: 25.5rem;
        line-height: 25.5rem;

        @media (max-width: ${BREAKPOINTS.lg}px) {
          font-size: 20.5rem;
          line-height: 20.5rem;
        }
        @media (max-width: ${BREAKPOINTS.sm}px) {
          font-size: 18.5rem;
          line-height: 18.5rem;
        }
        @media (max-width: ${BREAKPOINTS.xs}px) {
          font-size: 16rem;
          line-height: 16rem;
        }
        @media (max-width: ${BREAKPOINTS.xxs}px) {
          font-size: 14rem;
          line-height: 14rem;
        }
        @media (max-width: ${BREAKPOINTS.xxxs}px) {
          font-size: 12.5rem;
          line-height: 12.5rem;
        }
      `;
    default:
      return css`
        font-family: outward-block;
      `;
  }
};

export const LoadingWrapper = styled.div`
  ${setPosition({ position: "fixed", top: "0", left: "0", zIndex: 1000 })};
  background-color: ${props => props.$backgroundColor || "#fff"};
  height: 100lvh;
  width: 100%;
  overflow: hidden;
  opacity: 1;

  @media (max-width: ${BREAKPOINTS.md}px) {
    height: 100svh;
  }
`;

export const LoaderContainer = styled.div`
  ${setFlex({ align: "flex-end", justify: "flex-end" })};
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  height: 100lvh;
  width: 100%;
  overflow: hidden;

  @media (max-width: ${BREAKPOINTS.md}px) {
    height: 100svh;
  }
`;

export const LoaderTextContainer = styled.div`
  padding: 0 10rem;
  @media (max-width: ${BREAKPOINTS.md}px) {
    padding: 0 5rem;
  }
  @media (max-width: ${BREAKPOINTS.sm}px) {
    padding: 0 2.5rem;
  }
`;

export const LoaderText = styled.h1`
  ${props => setFontStyle(props.$articleId)};
  ${props => props.$fontColor && `color: ${props.$fontColor};`}
  margin: 0;
  font-weight: normal;
`;
